"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.set-prototype-of");

var _react = _interopRequireWildcard(require("react"));

var _lodashEs = require("lodash-es");

var _core = require("@material-ui/core");

var _red = _interopRequireDefault(require("@material-ui/core/colors/red"));

var _Input = _interopRequireDefault(require("@material-ui/icons/Input"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _reduxFormMaterialUi = require("redux-form-material-ui");

var _reduxForm = require("redux-form");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var red500 = _red.default['500'];
var style = {
  error: {
    color: red500
  }
};

var GirderLogin =
/*#__PURE__*/
function (_Component) {
  _inherits(GirderLogin, _Component);

  function GirderLogin() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, GirderLogin);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GirderLogin)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.render = function () {
      var _this$props = _this.props,
          error = _this$props.error,
          handleSubmit = _this$props.handleSubmit,
          pristine = _this$props.pristine,
          submitting = _this$props.submitting,
          invalid = _this$props.invalid,
          show = _this$props.show,
          title = _this$props.title,
          handleClose = _this$props.handleClose,
          loginFn = _this$props.loginFn,
          showMfa = _this$props.showMfa;
      return _react.default.createElement(_core.Dialog, {
        "aria-labelledby": "girder-dialog-title",
        open: show,
        onClose: handleClose
      }, _react.default.createElement(_core.DialogTitle, {
        id: "girder-dialog-title"
      }, title), _react.default.createElement("form", {
        onSubmit: handleSubmit(loginFn)
      }, _react.default.createElement(_core.DialogContent, null, _react.default.createElement("div", null, _react.default.createElement(_reduxForm.Field, {
        fullWidth: true,
        name: "username",
        component: _reduxFormMaterialUi.TextField,
        placeholder: "Username",
        label: "Username"
      })), _react.default.createElement("div", null, _react.default.createElement(_reduxForm.Field, {
        fullWidth: true,
        name: "password",
        component: _reduxFormMaterialUi.TextField,
        placeholder: "Password",
        label: "Password",
        type: "password"
      })), showMfa && _react.default.createElement("div", null, _react.default.createElement(_reduxForm.Field, {
        fullWidth: true,
        name: "mfa",
        component: _reduxFormMaterialUi.TextField,
        placeholder: "Multi-factor (if enabled)",
        label: "Multi-factor (if enabled)",
        type: "password"
      })), error && _react.default.createElement("div", {
        style: style.error
      }, (0, _lodashEs.has)(error, 'message') ? error.message : error)), _react.default.createElement(_core.DialogActions, null, _react.default.createElement(_core.Button, {
        disabled: pristine || submitting || invalid,
        variant: "contained",
        color: "secondary",
        type: "submit"
      }, _react.default.createElement(_Input.default, {
        className: "l-icon-btn"
      }), "Login"), _react.default.createElement(_core.Button, {
        disabled: submitting,
        variant: "contained",
        color: "secondary",
        onClick: function onClick() {
          return handleClose();
        }
      }, _react.default.createElement(_Clear.default, {
        className: "l-icon-btn"
      }), "Cancel"))));
    };

    return _this;
  }

  return GirderLogin;
}(_react.Component);

var _default = GirderLogin;
exports.default = _default;